import { FlexRow } from '@/components/common/Flex';
import FinancialEntityBalance from '@/components/financialEntities/FinancialEntityBalance';
import FinancialEntityWithMask from '@/components/financialEntities/FinancialEntityWithMask';
import { CenterProps, FlexProps } from '@chakra-ui/react';
import { AnyFinancialEntity, getName } from '@common/financialEntities';
import { FlexCol } from '../common/Flex';
import { Text } from '../common/Typography';
import { FinancialEntityIcon } from './FinancialEntityIcon';

interface AccountLockupProps extends FlexProps {
    account: AnyFinancialEntity;
    showMask?: boolean;
    showBalance?: boolean;
    showLoadingIndicator?: boolean;
    showLastUpdated?: boolean;
    maxW?: FlexProps['maxW'];
    iconProps?: CenterProps;
    additionalSubtitleContent?: JSX.Element;
}

export default function AccountLockup({
    account,
    showMask = true,
    maxW = 48,
    iconProps,
    additionalSubtitleContent,
    showBalance = false,
    showLoadingIndicator = true,
    showLastUpdated = true,
    ...props
}: AccountLockupProps) {
    const name = getName(account);

    return (
        <FlexRow minW={0} flexGrow={1} {...props}>
            <FlexRow flexGrow={showBalance ? 1 : undefined}>
                <FinancialEntityIcon
                    mt={0.5}
                    mr={4}
                    fe={account}
                    {...iconProps}
                />
                <FlexCol
                    minW={0}
                    maxW={maxW}
                    flexGrow={1}
                    justifyContent="center"
                >
                    <Text
                        overflow="hidden"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                    >
                        {name}
                    </Text>
                    <FlexRow gap={2}>
                        {showMask && account.mask && (
                            <Text color="textMuted" fontSize="sm">
                                <FinancialEntityWithMask
                                    fe={account}
                                    showName={false}
                                />
                            </Text>
                        )}
                        {additionalSubtitleContent}
                    </FlexRow>
                </FlexCol>
            </FlexRow>
            {showBalance && (
                <FinancialEntityBalance
                    fe={account}
                    pr={5}
                    showLastUpdated={showLastUpdated}
                    showLoadingIndicator={showLoadingIndicator}
                />
            )}
        </FlexRow>
    );
}
